import { render } from "./catalogPage.vue?vue&type=template&id=8eb21f20&scoped=true"
import script from "./catalogPage.vue?vue&type=script&lang=js"
export * from "./catalogPage.vue?vue&type=script&lang=js"

import "./catalogPage.vue?vue&type=style&index=0&id=8eb21f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb21f20"]])

export default __exports__